import ttf from './Quicksand-Regular.ttf';
import woff from './Quicksand-Regular.woff';
import woff2 from './Quicksand-Regular.woff2';

export default {
  name: 'Quicksand',
  variant: 'Regular',
  ttfUrl: ttf,
  woffUrl: woff,
  woff2Url: woff2,
} as const;
